import './notFound.css';
import Header from "components/header/header";

function NotFound() {
    return (
        <>
            <Header></Header>
            <div className="not-found new-order">
                <div>Oops. Ohh wat.</div>
                <div>where are u? 404...</div>
            </div>
        </>
    )
}

export default NotFound;